import { Grid } from '@mui/material';
import { RoutalLoader, RoutalPalette } from '@nx-smartmonkey/ui';

import { useSetSelectedDay } from '../hooks/useSetSelectedDay';
import { PlannerPlansDayHeader } from './PlannerPlansDayHeader';
import { PlannerPlansDayList } from './PlannerPlansDayList';

export const PlannerPlansDay = () => {
  const { selectedDay } = useSetSelectedDay();

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      style={{
        height: `100%`,
        border: `1px solid ${RoutalPalette.neutral10}`,
        borderRadius: `10px`,
      }}
    >
      <PlannerPlansDayHeader selectedDay={selectedDay} />
      {selectedDay ? (
        <PlannerPlansDayList selectedDay={selectedDay} />
      ) : (
        <Grid style={{ height: `100%`, width: `100%` }}>
          <RoutalLoader />
        </Grid>
      )}
    </Grid>
  );
};
